export default class enumsUtil{

  static childBodyType(v) {
    if (v == 1){
      return "婴儿"
    }
    if (v == 2){
      return "幼儿"
    }
    return "未知"
  }

  static lessonTemplateIdCF() {
    return 1;
  }
  static lessonTemplateIdBS() {
    return 2;
  }

  //用户购买课程卡状态
  static EUserBuyCardStatu() {

  }

}

export function EUserBuyCardStatu(v) {
  let d = [
    [0, '使用'],
    [1, '停用']
  ];
  for (let i =0;i< d.length;++i){
    if (v == d[i][0]){
      return d[i][1];
    }
  }
}

export function EAllGender() {
  return {
    BOY:{
      v:0,
      des:"男"
    },
    GORL:{
      v:1,
      des:"女"
    },
  }
}
export function EChildGender(v) {
  let d = [
    [0, '男'],
    [1, '女']
  ];
  for (let i =0;i< d.length;++i){
    if (v == d[i][0]){
      return d[i][1];
    }
  }
}

export function ECardExpType(v) {
  let d = [
    [0, 'VIP卡'],
    [1, '体验卡']
  ];
  for (let i =0;i< d.length;++i){
    if (v == d[i][0]){
      return d[i][1];
    }
  }
}




export function EReduceType(v) {
  let d = [
    [1, '扣正价'],
    [2, '扣赠送']

  ];
  for (let i =0;i< d.length;++i){
    if (v == d[i][0]){
      return d[i][1];
    }
  }
}

export function EChangeCardType(v) {
  let d = [
    [1, '重开卡'],
    [2, '调整'],
    [3, '停卡'],
    [4, '续卡'],
    [5, '新建卡'],

  ];
  for (let i =0;i< d.length;++i){
    if (v == d[i][0]){
      return d[i][1];
    }
  }
}

export function EClassServiceItemType() {

  return {
    SW_STATU:{
      v:1,
      des:"游泳状态"
    },
    SW_KIKING:{
      v:2,
      des:"踢腿"
    },
    SW_BREATE:{
      v:3,
      des:"换气/闭气"
    },
    SW_HANDMOVE:{
      v:4,
      des:"手部动作"
    },
    SW_HELPSELF:{
      v:5,
      des:"自救课"
    },
    SW_SPEED:{
      v:6,
      des:"速度"
    },
    SW_INTERACTIVE_CONTENT:{
      v:7,
      des:"互动内容"
    }
  }

}



export function EAllIntention() {

  return [
    {v:3, des:"A+"},
    {v:2, des:"A"},
    {v:4, des:"B+"},
    {v:1, des:"B"},
    {v:0, des:"C"},
    {v:5, des:"D"},
  ]

}

export function EAllFollowStage() {
  return [
    {v:0, des:"建立联系"},
    {v:1, des:"确认意向"},
    {v:2, des:"承诺到访"},
    {v:3, des:"预约试听"},
    {v:4, des:"完成试听"},
    {v:5, des:"完成缴费"},
    {v:6, des:"放弃"},
    {v:7, des:"重新跟进"}

  ]
}
export function getEnumDesByV(v,enums){
  for (let i =0;i< enums.length;++i){
    if (v == enums[i].v){
      return enums[i].des;
    }
  }
  return ""
}

export function ECardUseType() {
  return [
    {v:0, des:"通用卡"},
    {v:1, des:"周中卡"}
  ]
}



export function EAllLevelOption() {
  return [
    {label:"未设置", value:0,},
    {label:"三级", value:3,},
    {label:"四级", value:4,},
    {label:"五级", value:5,},
    {label:"六级", value:6,},
    {label:"七级", value:7,},
    {label:"八级", value:8,},
    {label:"九级", value:9,},
    {label:"十级", value:10,},
    {label:"十一级", value:11,},
    {label:"十二级", value:12,},
  ]
}
export function EAllLevelOptions() {
  return [
    {label:"未选择", value:0,},
    {label:"三级", value:3,},
    {label:"四级", value:4,},
    {label:"五级", value:5,},
    {label:"六级", value:6,},
    {label:"七级", value:7,},
    {label:"八级", value:8,},
    {label:"九级", value:9,},
    {label:"十级", value:10,},
    {label:"十一级", value:11,},
    {label:"十二级", value:12,},
  ]
}
export function getLevelDes(value) {
  let all = EAllLevelOption();
  for (let i =0;i< all.length;++i){
    if (value == all[i].value){
      return all[i].label;
    }
  }
}

export function EUserExpStatu() {
  return {
    NOT_EXP:0, //咨询未办卡
    EXP_NOT_VIP:1, //体验未办卡
    EXP_BUY_VIP:2, //体验并且办卡
  }
}














// WEBPACK FOOTER //
// ./src/utils/enumsUtil.js